<template>
  <div>
    <div class="m-title">{{ conf.title || '无' }}</div>
    <div class="board-box" v-loading="loading">
      <select-range @range-change="rangeChange" />
      <div :id="chartId" class="chart1"></div>
    </div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartBar1',
  props: {
    /**
     * 放置源头
     * - xcUnusual 客服-现场工程师异常服务单
     * - glNumCity 管理-现场服务单统计按城市
     */
    source: {
      type: String,
      default: 'xcUnusual'
    }
  },
  data() {
    return {
      chartData: {}
    }
  },
  computed: {
    conf: function() {
      const Map = {
        xcUnusual: {
          title: '现场工程师异常服务单数量',
          legendLeft: '12%',
          legend: '异常单',
          fieldConf: { xField: 'ENGINEER_NAME' }
        },
        glNumCity: {
          title: '现场服务单数量（按城市）',
          legend: '当前数量',
          // 独占一行，尺寸略有差异
          gridLeft: '5%',
          legendLeft: '6%',
          // TODO: 添加了 STORE_C_DIC 字段后，视图查询结果不生效
          fieldConf: { xField: 'STORE_C_DIC' }
          // fieldConf: { mock: true, xField: 'city' }
        }
      }

      return Map[this.source] || {}
    }
  },
  watch: {
    chartData: function() {
      this.updateChart()
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    updateChart: function() {
      let chartData = this.chartData,
        optConf = this.conf
      let options = {
        legend: {
          left: optConf.legendLeft || 'auto',
          top: '27',
          data: [optConf.legend]
        },
        series: [
          {
            name: optConf.legend,
            type: 'bar',
            itemStyle: { color: '#5B8FF9' },
            barMaxWidth: '14',
            data: chartData.series || []
          }
        ],
        xAxis: [
          {
            type: 'category',
            triggerEvent: optConf.triggerLabel,
            boundaryGap: true,
            data: chartData.xAxis || []
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '（个）',
            boundaryGap: [0.2, 0.2],
            min: 0,
            minInterval: 1
          }
        ],
        dataZoom: {
          show: true,
          start: 0,
          end: (10 * 100) / chartData.xAxis.length,
          height: 15
        },
        grid: { right: 30, left: optConf.gridLeft || '10%' },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        }
      }

      this.chartIns && this.chartIns.setOption(options)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList: function(list) {
      let { xField } = this.conf.fieldConf

      let xAxis = [],
        series = [],
        total = 0

      let categoryMap = {}

      list.map(v => {
        let curX = v[xField]

        if (!categoryMap[curX]) categoryMap[curX] = []
        categoryMap[curX].push(v)
      })

      xAxis = Object.keys(categoryMap)
      series = xAxis.map(curX => {
        let n = (categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)

        total += n
        return {
          name: [curX].join(','),
          value: n
        }
      })

      if (total !== list.length) console.warn('数据可能有问题')
      this.chartData = { xAxis, series, total }
    },

    /**
     * 获取数据
     * @param {import('./SelectRange.vue').IRange} range 选择日期、品牌、工程师
     */
    getData: function(range) {
      let condition = this.condition,
        /** @type {import('../index.vue').IRoleId} */ roleId = this.roleId,
        { mock, timeField = 'YW_SERVICE_ORDER_CREATE_TIME' } = this.conf.fieldConf

      if (range) {
        if (range.type === 'date') {
          const tf = 'YYYY-MM-DD'
          // 日期变化
          let [start = '', end = ''] = range.data.current
          if (start === end) {
            // LIKE
            condition[`${timeField}:2`] = start + '%'
          } else {
            // <= 接口不包含此临界值，故需 +1 或者拼接时分秒
            end = moment(end)
              .add(1, 'day')
              .format(tf)

            condition[`${timeField}:5`] = start
            condition[`${timeField}:6`] = end
          }
          if (!start && !end) {
            delete condition[`${timeField}:2`]
            delete condition[`${timeField}:5`]
            delete condition[`${timeField}:6`]
          }
        }
      }

      this.loading = true
      let requestFn = ''
      if (this.source === 'xcUnusual') {
        requestFn = this.api.queryList(
          'YW_SERVICE_ORDER_YICHANG_V1',
          { p2: condition, p9: '' },
          `${roleId}_chart_1_xcUnusual`
        )
      } else if (this.source === 'glNumCity') {
        requestFn = this.api.queryList('YW_SERVICE_ORDER_V1', { p2: condition, p9: '' }, `${roleId}_chart_3_glNumCity`)
      }
      requestFn.then(
        res => {
          this.loading = false

          let resData = res.result

          // TODO: 模拟数据
          if (mock) {
            resData = this.sourceList = this.genTableData(100)
          }

          this.processList(resData)
        },
        err => {
          this.loading = false
        }
      )
    }
  }
}
</script>

<style lang="postcss"></style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartBar1.vue